module.exports = __webpack_public_path__ + "img/banner-1.cf1d51c5.png";